import axios from './axios';

const MenuCustomizeService = {
    menugroupById: async (id) => {
        try {
            const response = await axios.get(`/menus/${id}/menu-groups`);
            return response.data.data;
        } catch(e) {
            console.error(e);
        } 
    },
    getMenuGroupItems: async(id) => {
        try {
            const response = await axios.get(`/menu-groups/${id}`);
            return response.data.data;
        } catch(e) {
            console.error(e);
        } 
    },
    getMenuCustomization: async (id) => {
        try {
            const response = await axios.get(`/menu-customization/${id}`);
            return response.data.data;
        } catch(e) {
            console.error(e);
        } 
    },
    saveMenuCustomization: async (payload) => {
        try {
            const response = await axios.post(`/menu-customization`, payload);
            return response.data;
        } catch(e) {
            console.error(e);
        } 
    },
    updateMenuCustomization: async (payload, id) => {
        try {
            const response = await axios.put(`/menu-customization/${id}`, payload);
            return response.data;
        } catch(e) {
            console.error(e);
        } 
    },
    deleteMenuCustomization: async(id) => {
        try {
            const response = await axios.delete(`/menu-customization/${id}`);
            return response.data.data;
        } catch(e) {
            console.error(e);
        } 
    },
    deleteCustomization: async(id) => {
        try {
            const response = await axios.delete(`/menu-customization/${id}`);
            return response.data.data;
        } catch(e) {
            console.error(e);
        } 
    },
    getCustomizationList: async() => {
        try {
            const response = await axios.get(`/menu-customization`);
            return response.data.data;
        } catch(e) {
            console.error(e);
        } 
    }
}
export default MenuCustomizeService;